/* assets/free-gift.js */
/*
  Enhanced Discount Detection:
    1) Checks window.location.search for “discount=” (e.g. ?discount=COMBODEAL).
    2) Checks cart.discount_amount or cart.discounts (cart-level code/auto discounts).
    3) Checks each item’s compare_at_price > price (variant-level pre-discounted bundles).

  If ANY of these conditions is true, the free-gift popup is hidden
  and any existing gift in the cart is removed immediately.
*/

(function() {
  // 1) Ensure the “freeGiftConfig” object is present (from Liquid snippet)
  if (!window.freeGiftConfig) {
    console.warn('freeGiftConfig not found – skipping free gift logic.');
    return;
  }

  // 2) Grab references to the modal elements (they exist in the DOM via snippet)
  var overlay         = document.getElementById('free-gift-overlay');
  var modalCloseBtn   = document.getElementById('free-gift-close');
  var confirmBtn      = document.getElementById('free-gift-confirm');
  var hiddenInput     = document.getElementById('free-gift-selected-variant');
  var swatchContainer = document.getElementById('free-gift-swatches');
  var previewImage    = document.getElementById('free-gift-preview');

  var CART_CHECK_INTERVAL = 1500; // Polling interval in milliseconds

  // 3) Helper: Fetch /cart.js JSON via Fetch API
  function fetchCart() {
    return fetch('/cart.js')
      .then(function(res) { return res.json(); })
      .catch(function(err) {
        console.error('Error fetching cart.json:', err);
        return null;
      });
  }

  // 4) Helper: Check if the gift is already in the cart
  function isGiftInCart(cart) {
    if (!cart || !cart.items) return false;
    return cart.items.some(function(item) {
      return item.product_id === window.freeGiftConfig.giftProductId;
    });
  }

  // 5) Helper: Find the 1-based “line” index for the gift in cart.items
  function findGiftLineIndex(cart) {
    if (!cart || !cart.items) return null;
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].product_id === window.freeGiftConfig.giftProductId) {
        return i + 1; // Shopify expects a 1-based line number for /cart/change.js
      }
    }
    return null;
  }

  // 6) Show / hide the modal overlay
  function showModal() {
    if (overlay) overlay.style.display = 'flex';
  }
  function hideModal() {
    if (overlay) overlay.style.display = 'none';
  }

  // 7) Add the selected free-gift variant (AJAX POST to /cart/add.js)
  function addGiftToCart(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
    .then(function(res) { return res.json(); })
    .catch(function(err) {
      console.error('Error adding gift to cart:', err);
    });
  }

  // 8) Remove the gift from cart (AJAX POST to /cart/change.js)
  function removeGiftFromCart(lineIndex) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        line: lineIndex,
        quantity: 0
      })
    })
    .then(function(res) { return res.json(); })
    .catch(function(err) {
      console.error('Error removing gift from cart:', err);
    });
  }

  // 9) Initialize swatch‐click behavior (highlight, update preview, set hidden <input>)
  function initSwatchClicks() {
    if (!swatchContainer || !previewImage || !hiddenInput) return;

    var swatches = swatchContainer.querySelectorAll('.free-gift-swatch');
    swatches.forEach(function(label) {
      label.addEventListener('click', function(evt) {
        evt.preventDefault();

        // a) Reset all swatch borders to #ddd
        swatches.forEach(function(el) {
          var innerBox = el.querySelector('div'); // the colored square
          if (innerBox) innerBox.style.borderColor = '#ddd';
          el.classList.remove('swatch--selected');
        });

        // b) Highlight clicked swatch (border‐color = #000)
        label.classList.add('swatch--selected');
        var chosenBox = label.querySelector('div');
        if (chosenBox) chosenBox.style.borderColor = '#000';

        // c) Update the hidden <input> with this variant’s ID
        var chosenId = label.getAttribute('data-variant-id');
        hiddenInput.value = chosenId;

        // d) Find that variant object to fetch its preview image URL + alt
        var variantObj = window.freeGiftConfig.giftVariants.find(function(v) {
          return v.id === parseInt(chosenId, 10);
        });
        if (variantObj) {
          previewImage.setAttribute('src', variantObj.imageUrl);
          previewImage.setAttribute('alt', variantObj.imageAlt);
        }
      });
    });

    // e) Pre‐select the very first swatch (if it exists)
    if (swatches.length) {
      swatches[0].click();
    }
  }

  // 10) Main logic: Check cart state → decide whether to show/hide modal → remove gift if needed
  function checkCartAndMaybeShow() {
    fetchCart().then(function(cart) {
      if (!cart) return;

      var cartTotal    = cart.total_price;            // in paise
      var threshold    = window.freeGiftConfig.threshold;
      var giftInCart   = isGiftInCart(cart);

      // --- A) Check if user manually added a “?discount=XYZ” parameter in URL ---
      var urlHasDiscountCode = window.location.search.includes('discount=');

      // --- B) Check for cart-level discount (automatic or code applied) ---
      var codeDiscountApplied = (cart.discount_amount > 0) ||
                                (Array.isArray(cart.discounts) && cart.discounts.length > 0);

      // --- C) Check for pre‐discounted items: any compare_at_price > price ---
      var itemLevelCompareDiscount = cart.items.some(function(item) {
        // compare_at_price may be null if not set; if set and greater than price, item is discounted
        return (item.compare_at_price > item.price);
      });

      // If ANY of A, B, or C is true, we treat it as “a discount is already active”
      var discountActive = urlHasDiscountCode || codeDiscountApplied || itemLevelCompareDiscount;

      if (discountActive) {
        // 1) Hide the free‐gift modal if open
        hideModal();

        // 2) If gift is already in cart, remove it automatically
        if (giftInCart) {
          var lineIndex = findGiftLineIndex(cart);
          if (lineIndex) {
            removeGiftFromCart(lineIndex);
          }
        }
        // 3) Skip out – do NOT show gift even if cart ≥ threshold
        return;
      }

      // --- D) No other discount detected → proceed with threshold-based logic ---

      // 1) If cart ≥ threshold AND gift not in cart → show modal
      if (cartTotal >= threshold && !giftInCart) {
        showModal();
      } else {
        hideModal();
      }

      // 2) If cart < threshold AND gift is in cart → remove gift
      if (cartTotal < threshold && giftInCart) {
        var lineIndex = findGiftLineIndex(cart);
        if (lineIndex) {
          removeGiftFromCart(lineIndex);
        }
      }
    });
  }

  // 11) Set up event listeners on DOMContentLoaded
  document.addEventListener('DOMContentLoaded', function() {
    // a) Initialize swatch clicks
    initSwatchClicks();

    // b) Run initial check
    checkCartAndMaybeShow();

    // c) If theme fires a “cart:updated” event on <body>, catch it
    document.body.addEventListener('cart:updated', function() {
      checkCartAndMaybeShow();
      setTimeout(checkCartAndMaybeShow, CART_CHECK_INTERVAL);
    });

    // d) “×” close button hides modal
    if (modalCloseBtn) {
      modalCloseBtn.addEventListener('click', function(e) {
        e.preventDefault();
        hideModal();
      });
    }

    // e) “Add Free Gift to Cart” button
    if (confirmBtn) {
      confirmBtn.addEventListener('click', function(e) {
        e.preventDefault();
        var chosenId = hiddenInput.value;
        if (!chosenId) return;
        addGiftToCart(parseInt(chosenId, 10)).then(function() {
          hideModal();
        });
      });
    }

    // f) Poll every CART_CHECK_INTERVAL ms in case no “cart:updated” event fires
    setInterval(checkCartAndMaybeShow, CART_CHECK_INTERVAL);
  });
})();
